export default {
  format(param) {
    param = isNaN(param) ? 0 : param;
    return Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(param);
  }
};
